import { clsx } from 'clsx';

const variants = {
  primary: 'bg-brand-navy text-white hover:bg-brand-navy-light hover:shadow-lg hover:shadow-brand-gold/20 focus:ring-brand-gold',
  secondary: 'bg-white text-brand-navy border border-gray-200 hover:bg-gray-50 focus:ring-brand-gold',
  danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
  ghost: 'text-brand-navy hover:bg-gray-50 focus:ring-gray-300',
  gold: 'bg-white text-brand-gold border border-brand-gold/30 hover:bg-brand-gold/10 focus:ring-brand-gold',
};

const sizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-5 py-2.5 text-[15px]',
  lg: 'px-6 py-3 text-base',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  className,
  disabled,
  loading,
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={clsx(
        'inline-flex items-center justify-center font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors',
        variants[variant],
        sizes[size],
        (disabled || loading) && 'opacity-60 cursor-not-allowed',
        className
      )}
      {...props}
    >
      {loading && (
        <span className="mr-2 inline-block w-4 h-4 border-2 border-brand-gold/40 border-t-brand-gold rounded-full animate-spin" />
      )}
      {children}
    </button>
  );
}
